module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h400"
  }, [_c('div', {
    staticClass: "text-center mt100",
    staticStyle: {
      "font-size": "120px"
    }
  }, [_vm._v("\n\t\t404\n\t")]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_vm._v("\n\t\t您访问的页面不存在！\n\t")]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("回到首页")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-65f0827a"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/lobby/view/404.vue
// module id = 996
// module chunks = 1